module.exports = __webpack_public_path__ + "static/media/greyhound.48e2eeff.svg";